onInteractive(function() {
	// The "Binnenkort" feed on the home page shows a short date ("23 okt"), the agenda itself the full date.
	document.querySelectorAll('.agenda-feed .blog-field-date').forEach(function(field) {
		var label = field.querySelector('.sr-only');
		var text = field.textContent.replace(label ? label.textContent : '', '').trim();
		var match = text.match(/^(\d{1,2}) ([a-z]{3})[a-z]* \d{4}$/i);
		if (!match) {
			return;
		}
		Array.from(field.childNodes).forEach(function(node) {
			if (node.nodeType === Node.TEXT_NODE) {
				node.remove();
			}
		});
		field.appendChild(document.createTextNode(match[1] + ' ' + match[2]));
	});

	// The month filter of the agenda only formats labels for date-and-time fields; the agenda uses a plain
	// date field, so its options arrive without text and get "Oktober 2026" style labels from their value.
	var monthFormat = new Intl.DateTimeFormat('nl-NL', { month: 'long', year: 'numeric' });
	document.querySelectorAll('.agenda-filters select option').forEach(function(option) {
		var match = option.value.match(/^(\d{4})-(\d{2})$/);
		if (!match || option.textContent.trim() !== '') {
			return;
		}
		var label = monthFormat.format(new Date(+match[1], +match[2] - 1, 1));
		option.textContent = label.charAt(0).toUpperCase() + label.slice(1);
	});

	// "Toon alle activiteiten" on the agenda swaps the event cards for the map. The choice is kept per
	// visitor in the browser, so the map stays open after a filter reloads the page.
	var viewToggle = document.querySelector('.agenda-view-toggle');
	var map = document.querySelector('.agenda-map');
	var cards = document.querySelector('.blog-template-agenda .blog-collection-items');
	if (viewToggle && map && cards) {
		var showView = function(view) {
			var showMap = view === 'map';
			map.hidden = !showMap;
			cards.hidden = showMap;
			viewToggle.querySelectorAll('input[name="agenda-view"]').forEach(function(input) {
				input.checked = input.value === view;
			});
			try {
				localStorage.setItem('agenda-view', view);
			} catch (error) {}
			// The map was drawn while hidden; a resize lets it fill its now visible box.
			window.dispatchEvent(new Event('resize'));
		};

		var savedView = null;
		try {
			savedView = localStorage.getItem('agenda-view');
		} catch (error) {}
		if (savedView === 'map') {
			showView('map');
		}

		viewToggle.querySelectorAll('input[name="agenda-view"]').forEach(function(input) {
			input.addEventListener('change', function() {
				showView(input.value);
			});
		});
	}
});
